import { Box } from '@mui/material';

export const CustomProgressBar = ({
	value = 0,
	bgColor = '#00D175',
	baseBgColor = '#96ECE0',
	borderRadius = '10px',
	labelColor = '#063236',
	labelSize = '14px',
	paddingY = '0px',
}) => {
	const filled = Math.min(Math.max(value, 0), 100);
	const remaining = 100 - filled;

	return (
		<Box sx={{ display: 'flex', width: '100%', alignItems: 'stretch' }}>
			{filled > 0 && (
				<Box sx={{
					width: `${filled}%`,
					minWidth: '56px',
					backgroundColor: bgColor,
					borderRadius,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'flex-start',
					paddingTop: paddingY,
					paddingBottom: paddingY,
					paddingLeft: '12px',
					color: labelColor,
					fontSize: labelSize,
					fontWeight: 'bold',
					flexShrink: 0,
					boxSizing: 'border-box',
					whiteSpace: 'nowrap',
				}}>
					{`${value}%`}
				</Box>
			)}
			{remaining > 0 && (
				<Box sx={{ flex: 1, backgroundColor: baseBgColor, borderRadius }} />
			)}
		</Box>
	);
};
